import { FC, useEffect, useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { RouteComponentProps, useRouteMatch } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { doGetThirdItems, doCreateThirdItem, doUpdateThirdItem } from '../../../store/criteria.slice';
import { doGetTypes } from '../../../store/convert.slice';
import { doRemoveAuth } from '../../../store/auth.slice';
import { RootState } from '../../../store/rootReducer';
import qs from 'qs';

import { useSnackbar } from 'notistack';
import { Button as AntButton, Modal, Select, Table, TableColumnsType } from 'antd';


import Loader from '../../../components/Loader';
import Header from '../../../components/layout/Header';
import Footer from '../../../components/layout/Footer';
import Button from '../../../components/Button';
import Radio from '../../../components/Radio';
import { successVariant, infoVariant, warningVariant, errorVariant } from '../../../lib/barVariant';
import useAuth from '../../../hooks/useAuth';
const { Option } = Select;

interface IMatch {
  id: string;
}

const ProgramCriteriaActivity: FC<RouteComponentProps> = ({ history, location }) => {
  const { writeAuthYn } = useAuth();
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const match = useRouteMatch<IMatch>();
  const parentCode = Number(match.params.id);
  const query = qs.parse(location.search, { ignoreQueryPrefix: true });

  const { thirdItems, isLoading } = useSelector((state: RootState) => state.criteria);
  const { types, isLoading: typeLoading } = useSelector((state: RootState) => state.convert);

  // 상위 메뉴 관련 처리용
  const [type, setType] = useState('');
  const [code, setCode] = useState('');
  const [topName, setTopName] = useState('');
  const [subName, setSubName] = useState('');

  const [inputVisible, setInputVisible] = useState(false);
  const [itemCode, setItemCode] = useState<number|null>(null);
  const [itemName, setItemName] = useState('');
  const [convertType, setConvertType] = useState<any>('');
  const [memo, setMemo] = useState('');
  const [useYn, setUseYn] = useState('Y');

  const itemNameInput = useRef<any>();

  useEffect(() => {
    // query to state
    if (query.type) setType(String(query.type));
    if (query.code) setCode(String(query.code));
    if (query.topName) setTopName(String(query.topName));
    if (query.subName) setSubName(String(query.subName));
  }, [location]);

  useEffect(() => {
    getThirdItems();
    getTypes();
  }, []);

  const getThirdItems = async () => {
    const res = await dispatch(doGetThirdItems(parentCode));

    switch (res?.status) {
      case 200:
        break;
      case 401:
        dispatch(doRemoveAuth());
        break;
      case 403:
        enqueueSnackbar(t('common.message.forbidden'), warningVariant);
        history.push('/');
        break;
      default:
        enqueueSnackbar(res?.data?.data || t('common.message.error'), errorVariant);
    }
  }

  const getTypes = async () => {
    const res = await dispatch(doGetTypes());

    switch (res?.status) {
      case 200:
        break;
      case 401:
        dispatch(doRemoveAuth());
        break;
      case 403:
        enqueueSnackbar(t('common.message.forbidden'), warningVariant);
        history.push('/');
        break;
      default:
        enqueueSnackbar(res?.data?.data || t('common.message.error'), errorVariant);
    }
  }

  const onOpenInputModal = () => {
    setItemCode(null);
    setItemName('');
    setConvertType(null);
    setMemo('');
    setUseYn('Y');
    setInputVisible(true);
  }

  const onSubmit = async () => {
    if (!itemName) {
      itemNameInput.current.focus();
      return enqueueSnackbar(t('program.criteria.message1'), infoVariant);
    }
    if (!convertType) {
      return enqueueSnackbar(t('program.criteria.message2'), infoVariant);
    }

    const req = {
      itemName,
      typeCode: convertType,
      memo,
      useYn
    }

    const res = itemCode
      ? await dispatch(doUpdateThirdItem(itemCode, req))
      : await dispatch(doCreateThirdItem(parentCode, req));

    switch (res?.status) {
      case 200:
        getThirdItems();
        setInputVisible(false);
        enqueueSnackbar(t('common.message.save1'), successVariant);
        break;
      case 401:
        dispatch(doRemoveAuth());
        break;
      case 403:
        enqueueSnackbar(t('common.message.forbidden'), warningVariant);
        history.push('/');
        break;
      default:
        enqueueSnackbar(res?.data?.data || t('common.message.error'), errorVariant);
    }
  }

  const columns: TableColumnsType<any> = [
    {
      title: t('program.criteria.column1'),
      dataIndex: 'itemName',
      key: 'itemName',
      align: 'center',
      width: '25%',
      sorter: (a, b) => a.itemName?.localeCompare(b.itemName),
    },
    {
      title: t('program.criteria.column3'),
      dataIndex: 'typeName',
      key: 'typeName',
      align: 'center',
      width: '150px',
      sorter: (a, b) => a.typeName?.localeCompare(b.typeName),
    },
    {
      title: 'Activity Code',
      dataIndex: '',
      key: '',
      align: 'center',
      width: '150px',
      sorter: (a, b) => a.typeName?.localeCompare(b.typeName),
    },
    {
      title: t('program.criteria.column5'),
      dataIndex: 'memo',
      key: 'memo',
      align: 'center',
      sorter: (a, b) => a.memo?.localeCompare(b.memo),
    },
    {
      title: t('program.criteria.column4'),
      dataIndex: 'useYn',
      key: 'useYn',
      align: 'center',
      width: '100px',
      sorter: (a, b) => a.useYn?.localeCompare(b.useYn),
    },
    {
      title: '',
      key: 'itemCode',
      dataIndex: 'itemCode',
      align: 'center',
      width: '100px',
      render: (value: string, record: any) => (
        <>
          <Button
            className='btn btn-sm btn-success btn-w100p'
            onClickCapture={event => {
              event.stopPropagation();
              setItemCode(record.itemCode || '');
              setItemName(record.itemName || '');
              setConvertType(record.typeCode || '');
              setMemo(record.memo || '');
              setUseYn(record.useYn || '');
              setInputVisible(true);
            }}
            text={t('common.button.edit')}
            writeAuthYn={writeAuthYn}
          />
        </>
      )
    },
  ];

  return (
    <div className="content-wrapper">
      {isLoading || typeLoading ? <Loader /> : null}
      <Header
        parentMenu={t('common.menu.program')}
        currentMenu={`${t('program.criteria.title1')} > ${topName} > ${subName}`}
      />
      <div className="main flex">
        <div className="col-12">
          <div>
            <div className="text-right">
              <Button
                className="btn btn-sm btn-primary btn-w100p ml-1"
                onClick={onOpenInputModal}
                text={t('program.award.button2')}
                writeAuthYn={writeAuthYn}
              />
            </div>
            <div className="card mt-3">
              <div className="card-body">
                <Table
                  columns={columns}
                  dataSource={thirdItems || undefined}
                  pagination={{
                    pageSize: 99999
                  }}
                  onRow={record => {
                    return {
                      onClick: () => {
                        history.push(`/program/criteria/${record.itemCode}/activity`);
                      }
                    };
                  }}
                  rowClassName="pointer"
                />
              </div>
            </div>
            <div className="flex flex-justify-between">
              <Button
                className="btn btn-sm btn-info btn-w100p"
                onClick={() => history.push(`/program/criteria/${code}/sub?type=${type}&name=${topName}`)}
                text={t('program.convert.button1')}
              />
              <Button
                className="btn btn-sm btn-primary btn-w100p"
                onClick={onOpenInputModal}
                text={t('program.award.button2')}
                writeAuthYn={writeAuthYn}
              />
            </div>
          </div>
        </div>
      </div>
      <Footer />

      {/* 입력 모달 */}
      <Modal
        className="select-agent-modal"
        title={`${t('program.criteria.title1')} > ${topName} > ${subName}`}
        visible={inputVisible}
        onCancel={() => setInputVisible(false)}
        footer={[
          <div className='comm-btn__area justify-content-center'>
            <AntButton
              key="submit"
              className='btn-basic pink'
              onClick={onSubmit}
            >
              {t('common.button.save')}
            </AntButton>
            <AntButton
              key="cancel"
              className='btn-basic gray'
              onClick={() => setInputVisible(false)}
            >
              {t('common.button.cancel')}
            </AntButton>
          </div>
        ]}
      >
        <div>
          <table className="table table-inside">
            <colgroup>
              <col width="20%" />
              <col width="80%" />
            </colgroup>
            <tbody>
              <tr>
                <th className="align-middle">{t('program.criteria.column1')}</th>
                <td>
                  <input
                    type="text"
                    className="form-control input-text"
                    value={itemName}
                    onChange={e => setItemName(e.target.value)}
                    ref={itemNameInput}
                  />
                </td>
              </tr>
              <tr>
                <th className="align-middle">{t('program.criteria.column3')}</th>
                <td>
                  <Select
                    className="w-100"
                    placeholder={t('common.button.select')}
                    value={convertType}
                    onChange={value => setConvertType(value)}
                  >
                    {
                      types?.map((item: any) => {
                        return (
                          <Option
                            key={item.typeCode}
                            value={item.typeCode}
                          >
                            {item.typeName}
                          </Option>
                        )
                      })
                    }
                  </Select>                  
                </td>
              </tr>
              <tr>
                <th className="align-middle">{t('program.criteria.column5')}</th>
                <td>
                  <input
                    type="text"
                    className="form-control input-text"
                    value={memo}
                    onChange={e => setMemo(e.target.value)}
                  />
                </td>
              </tr>
              <tr>
                <th className="align-middle">{t('program.criteria.column4')}</th>
                <td>
                  <Radio
                    checked={useYn === 'Y'}
                    onChange={() => setUseYn('Y')}
                    text={t('common.option.yes')}
                  />
                  <Radio
                    className="ml-4"
                    checked={useYn === 'N'}
                    onChange={() => setUseYn('N')}
                    text={t('common.option.no')}
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </Modal>
    </div>
  )
}

export default ProgramCriteriaActivity;
